import request from "./curl";
import iosBridge from './ios_bridge'

var video_utility = {
  /**
   * cloudvoice_start_call
   * Launch a video call with cloudvoice
   */
  cloudvoice_start_call(self, user_id, participant_is_admin, group_id, group_name){
    var post_data = new FormData();
    post_data.append("user_id", user_id);
    post_data.append("group_id", group_id);
    post_data.append('group_name', group_name);
    post_data.append('isAdmin', participant_is_admin);
    post_data.append('validation_api', process.env.VUE_APP_MESH_API+"/group_user_verification");

    request.curl(self, "getJWTCloudVoice", post_data, process.env.VUE_APP_MESH_DOMAIN)
    .then(response => {
      if(!response.resp_status){
        self.snackbar = true;
        self.err_msg = response.resp_msg;
        return false;
      }

      let token = response.resp_data;
      let url_str = 'https://devmeet.cloudvoice.in/'+group_id.replace("-","")+'?jwt='+token;

      if(window.webkit){
        iosBridge.sendMessage({"module":"launchInBrowser", "data":{"url":url_str}});
      }
      else{
        window.open(url_str, '_blank');
      }
    });
  },
};

export default video_utility;